import script from "./HtmlConstructorBlocksList.vue?vue&type=script&lang=ts&setup=true"
export * from "./HtmlConstructorBlocksList.vue?vue&type=script&lang=ts&setup=true"

import "./HtmlConstructorBlocksList.vue?vue&type=style&index=0&id=0d6c1698&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d6c1698"]])

export default __exports__